// Single-select searchable country dropdown — where the (competitor) brand is
// promoting. Drives the SEMrush market for its stats and affiliate metrics.
// Shared by Competitor Spy and Affiliate Gap add-brand forms.
import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import FlagImage from './FlagImage';
import { countries } from '../dashboard/CountryDropdown';

const SingleCountrySelect = ({ value, onChange, disabled, error }) => {
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);

  const selected = countries.find(c => c.code === value) || null;
  const filtered = countries.filter(c =>
    c.name.toLowerCase().includes(search.toLowerCase()) ||
    c.code.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (code) => {
    onChange(code);
    setSearch('');
    setOpen(false);
  };

  return (
    <div className="relative">
      <div className="relative">
        <input
          type="text"
          value={open ? search : (selected ? `${selected.name} (${selected.code})` : '')}
          onChange={(e) => setSearch(e.target.value)}
          onFocus={() => { setOpen(true); setSearch(''); }}
          placeholder="Search country..."
          disabled={disabled}
          className={`w-full px-4 py-3 pr-10 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-600 transition-colors bg-white dark:bg-slate-800 text-gray-900 dark:text-slate-100 ${
            error ? 'border-red-300 dark:border-red-700 focus:ring-red-500' : 'border-gray-200 dark:border-slate-700'
          } ${disabled ? 'bg-gray-50 dark:bg-slate-800 cursor-not-allowed' : ''}`}
        />
        <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-2 pointer-events-none">
          {selected && !open && <FlagImage countryCode={selected.code} size={16} />}
          <ChevronDown className="w-4 h-4 text-gray-400 dark:text-slate-500" />
        </div>
      </div>

      {open && !disabled && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)}></div>
          <div className="absolute z-20 w-full mt-1 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-600 rounded-lg shadow-lg max-h-60 overflow-y-auto">
            {filtered.length > 0 ? (
              filtered.map((country) => (
                <div
                  key={country.code}
                  onClick={() => handleSelect(country.code)}
                  className={`flex items-center gap-2 px-3 py-2 cursor-pointer ${
                    country.code === value
                      ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400'
                      : 'hover:bg-blue-50 dark:hover:bg-slate-700'
                  }`}
                >
                  <FlagImage countryCode={country.code} size={16} />
                  <span className="text-sm dark:text-slate-200">{country.name} ({country.code})</span>
                </div>
              ))
            ) : (
              <div className="px-3 py-2 text-sm text-gray-500 dark:text-slate-400">No countries found</div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SingleCountrySelect;
